export const API_URL = `https://${process.env.REACT_APP_API_URL}`
const SOCKET_URL = `wss://${process.env.REACT_APP_API_URL}`

export const fetcher = (url, headers) => {
  return fetch(url, {
    headers: {
      'content-type': 'application/json',
    },
    ...headers,
  }).then(response => {
    if (response.status === 200) {
      return response.json()
    }
    if (response.status === 204) {
      return Promise.resolve('ok')
    }
    throw new Error(response.statusText)
  })
}

export const API = {
  socket: `${SOCKET_URL}/socket`,
  requestAppointment: `${API_URL}/request-appointment`,
  providerAppointment: providerId =>
    `${API_URL}/providers/${providerId}/appointments?state=available`,
  appointment: appointmentId => `${API_URL}/appointments/${appointmentId}`,
  user: userId => `${API_URL}/users/${userId}`,
  bookings: `${API_URL}/bookings`,
  appointmentsByUserLocation: (userId, locationId) =>
    `${API_URL}/users/${userId}/locations/${locationId}/appointments`,
  location: locationId => `${API_URL}/locations/${locationId}`,
  graphApi: `${API_URL}/graphapi`,
}
